// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelInputContainer_duzo7 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label_ibvuU {
  font-weight: bold;
}

.input_UwwJw {
  background-color: var(--f1-background);
  border-radius: 8px;
  height: 30px;
  width: 100%;
  border: none;
  padding: 8px;

  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  outline: none;
}

.input_UwwJw[type="number"]::-webkit-inner-spin-button,
.input_UwwJw[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input_UwwJw[type="number"] {
  -moz-appearance: textfield;
}

.eye_Btnkl {
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/LabelInputComponent/LabelInputComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;;EAExB,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".labelInputContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.label {\n  font-weight: bold;\n}\n\n.input {\n  background-color: var(--f1-background);\n  border-radius: 8px;\n  height: 30px;\n  width: 100%;\n  border: none;\n  padding: 8px;\n\n  appearance: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n\n  outline: none;\n}\n\n.input[type=\"number\"]::-webkit-inner-spin-button,\n.input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.eye {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelInputContainer": `labelInputContainer_duzo7`,
	"label": `label_ibvuU`,
	"input": `input_UwwJw`,
	"eye": `eye_Btnkl`
};
export default ___CSS_LOADER_EXPORT___;
